interface FormatStakeInputValuePayload {
  currentValue: string;
  validationRegex: RegExp;
  decimalSeparator: string;
}

export function formatStakeInputValue({
  validationRegex,
  currentValue,
  decimalSeparator
}: FormatStakeInputValuePayload) {
  if (!currentValue) {
    return '';
  }

  if (validationRegex.test(currentValue)) {
    return currentValue;
  }

  const numberHasDecimalSeparator = currentValue.indexOf(decimalSeparator) !== -1;

  if (numberHasDecimalSeparator) {
    const [integerNumbers, decimalNumbers] = currentValue.split(decimalSeparator);
    return `${integerNumbers}${decimalSeparator}${decimalNumbers.slice(0, 2)}`;
  }

  return currentValue;
}
